export const normalizeFaqSlug = (slug: string): string => slug.toLowerCase();

export const faqSlugsMatch = (faqName: string, slug: string): boolean => normalizeFaqSlug(faqName) === normalizeFaqSlug(slug);
